/**
 * export url to different endpoints for FETCH consumption
 */
export const BaseURI = process.env.REACT_APP_BASEURI;

export const LoginUrl = process.env.REACT_APP_LoginUrl;

export const ResetPassword = process.env.REACT_APP_ResetPassword;

export const transactionHistory = process.env.REACT_APP_transactionHistory;

export const transctionDetails = process.env.REACT_APP_transctionDetails;

export const LatestTransction = process.env.REACT_APP_LatestTransction;

export const Fees = process.env.REACT_APP_Fees;

export const FeeDetails = process.env.REACT_APP_FeeDetails;

export const UpdateFee = process.env.REACT_APP_UpdateFee;

export const PaymentStatus = process.env.REACT_APP_PaymentStatus;

export const Profile = process.env.REACT_APP_Profile;

export const ChangePassword = process.env.REACT_APP_ChangePassword;

export const Accommodation = process.env.REACT_APP_Accommodation;

export const AccommodationDetails = process.env.REACT_APP_AccommodationDetails;

export const BookAccommodation = process.env.REACT_APP_BookAccommodation;

export const AccommodationBooking = process.env.REACT_APP_AccommodationBooking;

export const UpdateAccomodationRef =
  process.env.REACT_APP_UpdateAccomodationRef;

export const BookWithCoupon = process.env.REACT_APP_BookWithCoupon;

export const Documents = process.env.REACT_APP_Documents;

export const Courses = process.env.REACT_APP_Courses;

export const RegisterCourses = process.env.REACT_APP_RegisterCourses;

export const RegisteredCourses = process.env.REACT_APP_RegisteredCourses;

export const CourseDetails = process.env.REACT_APP_CourseDetails;

export const CourseConfig = process.env.REACT_APP_CourseConfig;

export const PassportUpload = process.env.REACT_APP_PassportUpload;

export const FirstSemesterExtraCourses = process.env.REACT_APP_FirstSemesterExtraCourses;

export const SecondSemesterExtraCourses = process.env.REACT_APP_SecondSemesterExtraCourses;

export const DeleteCourse = process.env.REACT_APP_UnregisterCourses;
